<template>
    <div class="card-container" v-if="details">
        <v-row v-for="(detail,i) in details" :key="i">
            <v-col cols="5" class="left-side">
                {{ detail.name }}
            </v-col>
            <v-col cols="7" class="right-side text-truncate">
                {{ detail.value }}
            </v-col>
            <v-col cols="12" class="col-divider"/>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "UserDetailsCard",
    props: {
        details: {
            type: Array,
            default: null,
        }
    }
}
</script>

<style scoped>

.card-container {
    background: #FFFFFF;
    border: 1px solid #F5F5F5;
    border-radius: 4px;
    padding: 18px 30px 30px;
}

.left-side {
    text-align: left;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
}

.right-side {
    text-align: right;
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
}

.col-divider {
    border-bottom: 1px solid #99CC00;
    padding: 0;
}

</style>